var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogNAct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.14 11.46C13.3046 11.46 15.87 8.89459 15.87 5.73C15.87 2.56541 13.3046 0 10.14 0C6.97538 0 4.40997 2.56541 4.40997 5.73C4.40997 8.89459 6.97538 11.46 10.14 11.46Z",
    fill: "url(#paint0_linear_21_283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.95 21.7C19.39 22.65 18.22 23.22 16.81 23.22H3.46998C2.06998 23.22 0.88998 22.65 0.32998 21.7C-0.11002 20.97 -0.11002 20.1 0.30998 19.32L3.02998 14.34C3.54998 13.38 4.88998 12.73 6.34998 12.73H13.93C15.39 12.73 16.73 13.38 17.26 14.34L19.97 19.32C20.39 20.1 20.39 20.97 19.95 21.7Z",
    fill: "url(#paint1_linear_21_283)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_283",
    x1: 4.40997,
    y1: 5.73,
    x2: 15.87,
    y2: 5.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F8AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39DEFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21_283",
    x1: -0.000019868,
    y1: 17.97,
    x2: 20.29,
    y2: 17.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F8AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39DEFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.29,
    height: 23.22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogNAct);
export default __webpack_public_path__ + "static/media/LogNAct.8a96356908cec179bb8da047efd888cf.svg";
export { ForwardRef as ReactComponent };